import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IDeclinedMeetingRequestForBuyerClient,
} from 'interfaceAdapter/gatewaySchemas/IDeclinedMeetingRequestForBuyerClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/decline/request_meeting`;

export class DeclinedMeetingRequestForBuyerClient implements IDeclinedMeetingRequestForBuyerClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, match_id, reason } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ match_id: match_id, reason: reason });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
